export default __webpack_public_path__ + "static/newsroom_thumbnail-0dcd084971bb0f72cbe31cf0410b9d69.jpg";